import { ENABLE_LCA_USER_UI_REDESIGN } from "../config/constants";
import UserListNew from "../screens/lcaUser/userList/UserListNew";
import UserList from "../screens/user/userList/UserList";
import { adminAccess, supplierAccess, userAccess } from "./useRoleAccess";

const UserGrid = ENABLE_LCA_USER_UI_REDESIGN ? <UserListNew /> : <UserList />;

export const UserRoutes = [
  {
    path: "/users",
    route: UserGrid,
    protectRoutes: true,
    roleGrantAccess: [...adminAccess, ...userAccess, ...supplierAccess]
  }
];
